// extracted by mini-css-extract-plugin
export var grid = "_2t-0";
export var span1 = "_2t-2";
export var span10 = "_2t-b";
export var span10L = "_2t-z";
export var span10M = "_2t-n";
export var span10Xl = "_2t-1b";
export var span11 = "_2t-c";
export var span11L = "_2t-10";
export var span11M = "_2t-o";
export var span11Xl = "_2t-1c";
export var span12 = "_2t-d";
export var span12L = "_2t-11";
export var span12M = "_2t-p";
export var span12Xl = "_2t-1d";
export var span1L = "_2t-q";
export var span1M = "_2t-e";
export var span1Xl = "_2t-12";
export var span2 = "_2t-3";
export var span2L = "_2t-r";
export var span2M = "_2t-f";
export var span2Xl = "_2t-13";
export var span3 = "_2t-4";
export var span3L = "_2t-s";
export var span3M = "_2t-g";
export var span3Xl = "_2t-14";
export var span4 = "_2t-5";
export var span4L = "_2t-t";
export var span4M = "_2t-h";
export var span4Xl = "_2t-15";
export var span5 = "_2t-6";
export var span5L = "_2t-u";
export var span5M = "_2t-i";
export var span5Xl = "_2t-16";
export var span6 = "_2t-7";
export var span6L = "_2t-v";
export var span6M = "_2t-j";
export var span6Xl = "_2t-17";
export var span7 = "_2t-8";
export var span7L = "_2t-w";
export var span7M = "_2t-k";
export var span7Xl = "_2t-18";
export var span8 = "_2t-9";
export var span8L = "_2t-x";
export var span8M = "_2t-l";
export var span8Xl = "_2t-19";
export var span9 = "_2t-a";
export var span9L = "_2t-y";
export var span9M = "_2t-m";
export var span9Xl = "_2t-1a";
export var stretch = "_2t-1";